import { cloneDeep } from 'lodash';

import {
    CLOSE_MINUS_PHRASE_LIBRARY_MODAL,
    CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA,
    EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA,
    MinusPhraseLibraryAction,
    OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL,
    RESET_MINUS_PHRASE_LIBRARY_GRID_DATA,
    SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA,
    UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH,
    UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA,
    UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS,
    UPDATE_MINUS_PHRASE_LIST_DATA
} from '../actions/minusPhraseLibrary';
import { getDefaultDynamicMinusPhraseLibraryColumns } from '../declarations/minus-phrase-library/minus-phrase-library';
import { ColumnsHelpers } from '../service/ColumnsHelpers/ColumnsHelpers';
import { LocalStorage, StorageKeyType } from '../service/Storage/Storage';
import { ColumnsSettingsViewDict, minusPhraseLibrary as minusPhraseLibraryView } from '../typings/common';
import { defaultRowsCount } from '../typings/grid';
import { MinusPhraseLibraryState, State } from '../typings/state';

const minusPhraseLibraryInitialState: MinusPhraseLibraryState = {
    gridData: {
        total: defaultRowsCount,
        allItemsIds: [],
        data: [],
        campaignsIds: []
    },
    columnsSettings: ColumnsHelpers.getColumns(
        {
            [minusPhraseLibraryView]: getDefaultDynamicMinusPhraseLibraryColumns()
        },
        LocalStorage.getItem(StorageKeyType.minusPhraseLibrarySettings) as ColumnsSettingsViewDict
    ),
    isHeaderVisible: true,
    modalStatus: {
        isVisible: false
    },
    minusPhraseList: {
        title: '',
        minusPhrases: ''
    }
};

export function minusPhraseLibrary(
    state: MinusPhraseLibraryState = minusPhraseLibraryInitialState,
    action: MinusPhraseLibraryAction,
    fullState: State
): MinusPhraseLibraryState {
    switch (action.type) {
        case RESET_MINUS_PHRASE_LIBRARY_GRID_DATA:
            return {
                ...state,
                gridData: {
                    total: defaultRowsCount,
                    allItemsIds: [],
                    data: [],
                    campaignsIds: []
                }
            };
        case UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA:
            return {
                ...state,
                gridData: action.gridData
            };
        case UPDATE_MINUS_PHRASE_LIST_DATA:
            return {
                ...state,
                minusPhraseList: {
                    ...state.minusPhraseList,
                    title: action.title,
                    minusPhrases: action.minusPhrases
                }
            };
        case OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL:
            return {
                ...state,
                minusPhraseList: {
                    ...state.minusPhraseList,
                    id: state.gridData.data[action.index].id
                }
            };
        case UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };
        case UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS:
            return {
                ...state,
                modalStatus: {
                    isVisible: action.isVisible,
                    modalType: action.modalType
                }
            };
        case CLOSE_MINUS_PHRASE_LIBRARY_MODAL:
            return {
                ...state,
                modalStatus: {
                    isVisible: false
                },
                minusPhraseList: {
                    title: '',
                    minusPhrases: ''
                },
                errors: undefined
            };
        case CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA:
        case EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA:
            return {
                ...state,
                modalStatus: {
                    ...state.modalStatus,
                    isLoading: true
                },
                errors: undefined
            };
        case SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA:
            return {
                ...state,
                errors: action.error,
                modalStatus: {
                    ...state.modalStatus,
                    isLoading: false
                }
            };
        default:
            return state;
    }
}
